import { genres } from "@/mocks/siteContent";

export default function HeroSection() {
  return (
    <section id="top" className="relative flex min-h-[640px] w-full items-center overflow-hidden md:min-h-[780px]">
      <img
        src="https://readdy.ai/api/search-image?query=an%20abstract%20stylized%20cinematic%20atmosphere%20with%20warm%20amber%20light%20beams%20cutting%20through%20soft%20haze%2C%20deep%20shadow%2C%20fine%20film%20grain%20texture%2C%20dark%20moody%20gradient%2C%20subtle%20golden%20bokeh%2C%20elegant%20and%20dramatic%2C%20no%20people%2C%20no%20text%2C%20no%20watermark%2C%20high%20detail%2C%20wide%20cinematic%20composition&width=1920&height=1080&seq=ethilmic-hero&orientation=landscape"
        alt=""
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/60 to-foreground-950/85"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/40 via-transparent to-accent-950/40"></div>

      <div className="relative z-10 w-full px-4 pb-16 pt-32 md:px-8 md:pb-20 md:pt-36">
        <div className="mx-auto max-w-5xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 font-label text-xs text-background-50/90 backdrop-blur">
            <i className="ri-fire-line text-primary-300"></i>
            高清中字 · 排行榜 · 主题合集 每日更新
          </span>

          <h1 className="mx-auto mt-6 max-w-4xl font-heading text-4xl leading-[1.15] text-background-50 md:text-6xl">
            伦理片在线观看推荐
          </h1>

          <p className="mx-auto mt-6 max-w-3xl text-sm leading-relaxed text-background-100/85 md:text-lg">
            从每日更新的口碑排行榜，到按主题打包的高清中字合集，这里把「今晚看什么」这件事收在同一页里。
            先看趋势，再按题材挑片，最后用一段编辑手记确认——不用在多个站点之间来回比较。
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#ranking"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-bar-chart-2-line"></i>
              查看本周榜单
            </a>
            <a
              href="#collections"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 bg-background-50/10 px-6 py-3 text-sm text-background-50 backdrop-blur transition-colors hover:bg-background-50/20 sm:w-auto"
            >
              <i className="ri-stack-line"></i>
              浏览高清合集
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap items-center justify-center gap-2">
            {genres
              .filter((genre) => genre !== "全部")
              .map((genre) => (
                <li
                  key={genre}
                  className="rounded-full border border-background-50/20 bg-background-50/5 px-3 py-1 font-label text-xs text-background-100/80"
                >
                  {genre}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </section>
  );
}